module.exports = {
  'lang': 'zh-cn',
  'loading': '加载中...',
  'en-us': {
    'loading': 'Loading...'
  },
  'zh-tw': {
    'loading': '加載中...'
  }
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-spin/src/i18n.js